import { Component, OnInit } from '@angular/core';
import {AuthService} from '../core/services/auth.service';
import {environment} from '../../environments/environment';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  public user = null;
  public isDemo = true;
  public isTest = false;

  constructor(public auth: AuthService) {
    this.isDemo = environment.isDemo;
    this.isTest = sessionStorage.getItem('test') == 'true';
    auth.currentUser.subscribe(res => {
      this.user = res;
    });
  }

  ngOnInit(): void {
  }

}
